<div class="betslip-edit-bet_result_header">
    <div></div>
    <div class="betslip-edit-bet_result_header_title">{{ siteCore.betslip.editBet.header }}</div>
    <div class="betslip-edit-bet_result_header_close-button" *msShowInEpcot="false" (click)="clickHandler()">
        <i class="theme-close-i"></i>
    </div>
    <div class="betslip-edit-bet_result_header_close-button" *msShowInEpcot="true" (click)="clickHandler()">
        {{ siteCore.globalMessages.Close }}
    </div>
</div>
